const Login = () => System.import( /* webpackChunkName: "Login" */ '@/components/pages/login/Login.vue')
const Home = () => System.import( /* webpackChunkName: "Homehome" */ '@/components/pages/home/Home.vue')

const Principal = () => System.import(/* webpackChunkName: "Principal" */'@/components/shared/Principal.vue')
const AlterarSenha = () => System.import(/* webpackChunkName: "AlterarSenha" */'@/components/pages/perfil/AlterarSenha.vue')
const CadastroUsuario = () => System.import(/* webpackChunkName: "CadastroUsuario" */'@/components/pages/usuario/CadastroUsuario.vue')
const ListarUsuarios = () => System.import(/* webpackChunkName: "ListarUsuarios" */'@/components/pages/usuario/ListarUsuarios.vue')
const VisualizarUsuario = () => System.import(/* webpackChunkName: "VisualizarUsuario" */'@/components/pages/usuario/VisualizarUsuario.vue')
const RelatorioUsuario = () => System.import(/* webpackChunkName: "RelatorioUsuario" */'@/components/pages/usuario/RelatorioUsuario.vue')
const CadastroCidade = () => System.import(/* webpackChunkName: "CadastroCidade" */'@/components/pages/cidade/CadastroCidade.vue')
const ListarEstados = () => System.import(/* webpackChunkName: "ListarEstados" */'@/components/pages/cidade/ListarEstados.vue')
const VisualizarEstado = () => System.import(/* webpackChunkName: "VisualizarEstado" */'@/components/pages/cidade/VisualizarEstado.vue')
const ListarCidades = () => System.import(/* webpackChunkName: "ListarCidades" */'@/components/pages/cidade/ListarCidades.vue')
const VisualizarCidade = () => System.import(/* webpackChunkName: "visualizarCidade" */'@/components/pages/cidade/VisualizarCidade.vue')
const RelatorioCidade = () => System.import(/* webpackChunkName: "RelatorioCidade" */'@/components/pages/cidade/RelatorioCidade.vue')
const CadastroEstado = () => System.import(/* webpackChunkName: "CadastroEstado" */'@/components/pages/cidade/CadastroEstado.vue')
const CadastroEdicao = () => System.import(/* webpackChunkName: "CadastroEdicao" */'@/components/pages/edicao/CadastroEdicao.vue')
const Inscricoes = () => System.import(/* webpackChunkName: "Inscricoes" */'@/components/pages/inscricao/Inscricoes.vue')
const FormRematricula = () => System.import(/* webpackChunkName: "FormRematricula" */'@/components/pages/inscricao/FormRematricula.vue')
const GerenciaInscricao = () => System.import(/* webpackChunkName: "GerenciaInscricao" */'@/components/pages/inscricao/GerenciaInscricao.vue')
const AlteraInscricao = () => System.import(/* webpackChunkName: "AlteraInscricao" */'@/components/pages/inscricao/FormInscricao.vue')
const RelatorioInscricao = () => System.import(/* webpackChunkName: "RelatorioInscricao" */'@/components/pages/inscricao/RelatorioInscricao.vue')
const ComparativoCidades = () => System.import(/* webpackChunkName: "ComparativoCidades" */'@/components/pages/relatorio/ComparativoCidades.vue')
const GerarCertificado = () => System.import(/* webpackChunkName: "GerarCertificado" */'@/components/pages/inscricao/GerarCertificado.vue')
const EnviarCertificado = () => System.import(/* webpackChunkName: "EnviarCertificado" */'@/components/pages/inscricao/EnviarCertificado.vue')
const ListarEdicao = () => System.import(/* webpackChunkName: "ListarEdicao" */'@/components/pages/edicao/ListarEdicao.vue')
const VisualizarEdicao = () => System.import(/* webpackChunkName: "VisualizarEdicao" */'@/components/pages/edicao/VisualizarEdicao.vue')
const ResumoEvento = () => System.import(/* webpackChunkName: "ResumoEvento" */'@/components/pages/relatorio/ResumoEvento.vue')
const GerenciaRestricao = () => System.import(/* webpackChunkName: "GerenciaRestricao" */'@/components/pages/restricao/GerenciaRestricao.vue')
const GerenciaConfronto = () => System.import(/* webpackChunkName: "GerenciaConfronto" */'@/components/pages/confronto/GerenciaConfronto.vue')
const IncluirConfronto = () => System.import(/* webpackChunkName: "IncluirConfronto" */'@/components/pages/confronto/IncluirConfronto.vue')
const ListaConfronto = () => System.import(/* webpackChunkName: "ListaConfronto" */'@/components/pages/confronto/ListaConfronto.vue')
const RelatorioConfronto = () => System.import(/* webpackChunkName: "RelatorioConfronto" */'@/components/pages/relatorio/RelatorioConfronto.vue')
const RelatorioResultado = () => System.import(/* webpackChunkName: "RelatorioResultado" */'@/components/pages/relatorio/RelatorioResultado.vue')
const RelatorioCertificado = () => System.import(/* webpackChunkName: "RelatorioCertificado" */'@/components/pages/relatorio/RelatorioCertificado.vue')
const RelatorioCidadesSemConfronto = () => System.import(/* webpackChunkName: "RelatorioCidadesSemConfronto" */'@/components/pages/relatorio/RelatorioCidadesSemConfronto.vue')
const Logout = () => System.import(/* webpackChunkName: "Logout" */'@/components/pages/logout/Logout.vue')
const AccessDenied = () => System.import(/* webpackChunkName: "AccessDenied" */'@/components/shared/AccessDenied.vue')
const Error404 = () => System.import(/* webpackChunkName: "Error404" */'@/components/shared/404.vue')
const Redirect = () => System.import(/* webpackChunkName: "Redirect" */'@/components/shared/redirect/Redirect.vue')
const CalcularRanking = () => System.import(/* webpackChunkName: "CalcularRanking" */'@/components/pages/edicao/CalcularRanking.vue')


import Vue from 'vue'
import VueRouter from 'vue-router';
import JWT from 'jsonwebtoken'
import store from '../store/index.js'
import * as Cookies from 'js-cookie'
import config from '@/config/config.js'
import i18n from '@/i18n/index.js';

import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails,
    CognitoRefreshToken
} from 'amazon-cognito-identity-js';

var routes = [
    { path: '/login', name: 'login', component: Login, meta: {public: true, exibeMenu: false, ignore: true, titulo: 'Login'}},
    { path: '/', name: 'sesc', component: Principal, meta: {exibeMenu: false, ignore: false, titulo: 'Sesc - Sistema Dia do Desafio'},
      children: [
        { path: 'home', name: 'home', titulo: 'Início', component: Home, meta: {exibeMenu: true, ignore: true}},
        { path: 'logout', name: 'logout', icone: "glyphicon glyphicon-log-out", component: Logout, meta: {exibeMenu: true, ignore: true, titulo: 'Logout'}},
        { path: 'denied', name: 'denied', component: AccessDenied, meta: {exibeMenu: false, ignore: true, titulo: 'Acesso Negado'}},
        { path: 'redirect', name: 'redirect', component: Redirect, meta: {exibeMenu: false, ignore: true, titulo: 'Redirect'}}
      ]
    },

    { path: '/perfil', name: 'perfil', icone: "glyphicon glyphicon-user", component: Principal, meta: {exibeMenu: false, ignore: false, right: true, titulo: 'Perfil', exibeIdioma: true},
      children: [
        { path: 'alteraPerfil', name: 'alteraPerfil', icone: "glyphicon glyphicon-cog", component: AlterarSenha, meta: {exibeMenu: true, ignore: false, right: true, titulo: 'Alterar Senha'}}
      ]
    },
    
    { path: '/usuario', name: 'usuario', component: Principal, meta: {exibeMenu: false, ignore: false, titulo: 'Usuários'},
      children: [
        {path: 'incluiUsuario', name: 'incluiUsuario', component: CadastroUsuario, meta: {exibeMenu: true, ignore: false, titulo: 'Incluir Usuário'}},
        {path: 'listaUsuario',  name: 'listaUsuario', component: ListarUsuarios, meta: {exibeMenu: true, ignore: false, titulo: 'Listar Usuários'}},
        {path: 'visualizaUsuario',  name: 'visualizaUsuario', component: VisualizarUsuario, meta: {exibeMenu: false, ignore: false, titulo: 'Visualizar Usuário'}},
        {path: 'alteraUsuario',  name: 'alteraUsuario', component: CadastroUsuario, meta: {exibeMenu: false, ignore: false, titulo: 'Editar Usuário'}}
      ]
    },

    { path: '/cidade',  name: 'cidade', component: Principal, meta: {exibeMenu: false, ignore: false, titulo: 'Cidades'},
      children: [
        {path: 'incluiCidade',  name: 'incluiCidade', component: CadastroCidade, meta: {exibeMenu: true, ignore: false, titulo: 'Incluir Cidade'}},
        {path: 'listaCidade',   name: 'listaCidade', component: ListarCidades, meta: {exibeMenu: true, ignore: false, titulo: 'Listar Cidades'}},
        {path: 'alteraCidade',  name: 'alteraCidade', component: CadastroCidade, meta: {exibeMenu: false, ignore: false, titulo: 'Editar Cidade'}},
        {path: 'visualizaCidade',   name: 'visualizaCidade', component: VisualizarCidade, meta: {exibeMenu: false, ignore: false, titulo: 'Visualizar Cidade'}},
        {path: 'incluiEstado',  name: 'incluiEstado', component: CadastroEstado, meta: {exibeMenu: true, ignore: false, titulo: 'Incluir Estado'}},
        {path: 'listaEstado',  name: 'listaEstado', component: ListarEstados, meta: {exibeMenu: true, ignore: false, titulo: 'Listar Estado'}},
        {path: 'visualizaEstado',   name: 'visualizaEstado', component: VisualizarEstado, meta: {exibeMenu: false, ignore: false, titulo: 'Visualizar Estado'}},
        {path: 'alteraEstado',  name: 'alteraEstado', component: CadastroEstado, meta: {exibeMenu: false, ignore: false, titulo: 'Editar Estado'}}
      ]
    },

    {
        path: '/edicao',
        name: 'edicao',
        component: Principal,
        meta: { exibeMenu: false, ignore: false, titulo: 'Edições' },
        children: [
            { path: 'incluiEdicao', name: 'incluiEdicao', component: CadastroEdicao, meta: { exibeMenu: true, ignore: false, titulo: 'Incluir Edição' } },
            { path: 'listaEdicao', name: 'listaEdicao', component: ListarEdicao, meta: { exibeMenu: true, ignore: false, titulo: 'Listar Edições' } },
            { path: 'alteraEdicao', name: 'alteraEdicao', component: CadastroEdicao, meta: { exibeMenu: false, ignore: false, titulo: 'Alterar Edição' } },
            { path: 'visualizaEdicao', name: 'visualizaEdicao', component: VisualizarEdicao, meta: { exibeMenu: false, ignore: false, titulo: 'Visualizar Edição' } },
            { path: 'calcularRanking', name: 'calcularRanking', component: CalcularRanking, meta: { exibeMenu: true, ignore: false, titulo: 'Calcular Ranking' } }
        ]
    },

    { path: '/inscricao',  name: 'inscricao', component: Principal, meta: {exibeMenu: false, ignore: false, titulo: 'Inscrições'},
      children: [
        {path: 'publicaInscricao',  name: 'publicaInscricao', component: Inscricoes, meta: {exibeMenu: true, ignore: false, titulo: 'Publicar/Despublicar Inscrições'}},
        {path: 'listaInscricao',  name: 'listaInscricao', component: GerenciaInscricao, meta: {exibeMenu: true, ignore: false, titulo: 'Gerenciar Inscrições'}},
        {path: 'incluiRematricula',   name: 'incluiRematricula', component: FormRematricula, meta: {exibeMenu: false, ignore: false, titulo: 'Incluir Rematricula'}},
        {path: 'incluiInscricao',   name: 'incluiInscricao', component: AlteraInscricao, meta: {exibeMenu: false, ignore: false, titulo: 'Incluir Inscrição'}},
        {path: 'alteraInscricao',   name: 'alteraInscricao', component: AlteraInscricao, meta: {exibeMenu: false, ignore: false, titulo: 'Alterar Inscrição'}},
        {path: 'listaRestricao',  name: 'listaRestricao', component: GerenciaRestricao, meta: {exibeMenu: true, ignore: false, titulo: 'Gerenciar Restrição'}},
        {path: 'geraCertificado',  name: 'geraCertificado', component: GerarCertificado, meta: {exibeMenu: true, ignore: false, titulo: 'Gerar Certificados'}},
        {path: 'incluiCertificado',  name: 'incluiCertificado', component: EnviarCertificado, meta: {exibeMenu: false, ignore: false, titulo: 'Enviar Modelos de Certificados'}},
        {path: 'comparativoCidades',  name: 'comparativoCidades', component: ComparativoCidades, meta: {exibeMenu: true, ignore: false, titulo: 'Comparativo de Cidades'}},
      ]
    },

    { path: '/confronto',  name: 'confronto', component: Principal, meta: {exibeMenu: false, ignore: false, titulo: 'Confrontos'},      children: [
        {path: 'gerenciaConfronto',  name: 'gerenciaConfronto', component: GerenciaConfronto, meta: {exibeMenu: true, ignore: false, titulo: 'Gerenciar Confrontos'}},
        {path: 'listaConfronto',  name: 'listaConfronto', component: ListaConfronto, meta: {exibeMenu: false, ignore: false, titulo: 'Listar Confrontos'}},
        {path: 'incluiConfronto',   name: 'incluiConfronto', component: IncluirConfronto, meta: {exibeMenu: false, ignore: false, titulo: 'Incluir Confronto'}},
        {path: 'alteraConfronto',   name: 'alteraConfronto', component: IncluirConfronto, meta: {exibeMenu: false, ignore: false, titulo: 'Alterar Confronto'}},
      ]
    },

    { path: '/relatorio',  name: 'relatorio', component: Principal, meta: {exibeMenu: true, ignore: false, titulo: 'Relatorios'},      children: [
        {path: 'relatorioCidade',  name: 'relatorioCidade', component: RelatorioCidade, meta: {exibeMenu: false, ignore: false, titulo: 'Relatório de Cidades'}},
        {path: 'relatorioCertificado',  name: 'relatorioCertificado', component: RelatorioCertificado, meta: {exibeMenu: true, ignore: false, titulo: 'Relatório de Certificados'}},
        {path: 'relatorioUsuario',  name: 'relatorioUsuario', component: RelatorioUsuario, meta: {exibeMenu: true, ignore: false, titulo: 'Relatório de Usuários'}},
        {path: 'relatorioInscricao',  name: 'relatorioInscricao', component: RelatorioInscricao, meta: {exibeMenu: true, ignore: false, titulo: 'Relatório de Inscrições'}},
        {path: 'relatorioCidadesSemConfronto',  name: 'relatorioCidadesSemConfronto', component: RelatorioCidadesSemConfronto, meta: {exibeMenu: true, ignore: false, titulo: 'Relatório de Cidades sem Confronto'}},
        {path: 'relatorioConfronto',  name: 'relatorioConfronto', component: RelatorioConfronto, meta: {exibeMenu: true, ignore: false, titulo: 'Confronto entre Cidades'}},
        {path: 'relatorioResultado',  name: 'relatorioResultado', component: RelatorioResultado, meta: {exibeMenu: true, ignore: false, titulo: 'Resultados Gerais'}},
        { path: 'resumoEvento', name: 'resumoEvento', component: ResumoEvento, meta: { exibeMenu: true, ignore: false, titulo: 'Resumo do Evento' } }
      ]
    },

    { path: '*', name:"404", component: Error404, meta: { exibeMenu: true, ignore: true, titulo: '404 - Página inexistente' } }

];

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    mode: 'history',

});

export default router;

try {
    var mensagemErro = i18n.t('rotas.label.erro-generico');

    function getLifeTimeCookie() {
        var date = new Date();
        var minutes = config.cookie.cookieTime;
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        return date;
    };

    function validaDadosUsuario() {
        if (store.getters.getUserInfoIsNotEmpty) {
            if (Cookies.get(config.cookie.cookieName) == store.state.usuario.hash) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    function renewToken(refreshToken, payload, callback) {
        var now = Date.now()
        var timestampAtual = Math.floor(now / 1000);
        var tempoDecorrido = timestampAtual - payload.iat;

        if (tempoDecorrido > config.token.renewDelay) {

            var token = new CognitoRefreshToken({ RefreshToken: refreshToken });
            var userData = {
                Username: payload.username,
                Pool: new CognitoUserPool(config.cognito.poolData)
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.refreshSession(token, (err, session) => {
                if (err) {
                    callback(false, true);
                } else {
                    store.dispatch('saveUserToken', session)

                    //renova cookie
                    var temp = Cookies.get(config.cookie.cookieName)
                    Cookies.set(config.cookie.cookieName, temp, { expires: getLifeTimeCookie() })

                    callback(true, false);
                }
            });
        } else {
            callback(false, false);
        }
    };

    function validateJwt(token, callback) {
        try {
            var decode = JWT.decode(token, { complete: true })
            var kid = decode.header.kid;
            var retorno = JWT.verify(token, config.cognito.pems[kid], { issuer: config.cognito.iss })

            if (retorno) {
                renewToken(store.state.usuario.session.refreshToken, retorno, (renovou, deslogar) => {
                    if (renovou) { //Caso tenha renovado o AccessToken retorna o mesmo no callback para atualizar os Cookies
                        callback(true)
                    } else {
                        if (deslogar) { //Ocorreu algum erro ao renovar o AccessToken, pode ter ocorrido alteração do RefreshToken, deve deslogar.
                            callback(false)
                        } else { //Somente não renovou o AccessToken, continua com o mesmo.
                            callback(true)
                        }
                    }
                });
            } else {
                callback(false)
            }
        } catch (error) {
            if(error.name == 'TokenExpiredError'){
                mensagemErro = i18n.t('rotas.label.sessao-expirada');
            }
            callback(false)
        }

    };
    
    router.afterEach(function(transition) {
       //if (transition.name == 'login') { return }

        let accessToken = store.state.usuario.session.accessToken

        if (accessToken == '' || accessToken == undefined) {
            if(router.currentRoute.params['destino'] != undefined && router.currentRoute.params['destino'] != '' && transition.name == 'redirect'){
                return
            }else{
                if(transition.name == 'sesc') {
                    return router.push({ name: 'login'});
                }else{
                    mensagemErro = i18n.t('rotas.label.token-undefined');
                    return router.push({ name: 'login', params: { errorMessage: mensagemErro } })
                }
            }
        }else{
            validateJwt(accessToken, function(validou) {
                if (validaDadosUsuario() && validou) {
                    if (transition.name == 'sesc') { return router.push({ name: 'home' }) }

                    if (store.state.usuario.permissoes[transition.name] || transition.meta.ignore) {
                        return
                    } else {
                        router.push({ name: 'denied' })
                    }
                } else {
                    router.push({ name: 'login', params: { errorMessage: mensagemErro } });
                    $('#loading').modal('hide');
                }
            });
        }
        

    });
} catch (error) {
    router.push({ name: 'login', params: { errorMessage: this.mensagemErro } });
    $('#loading').modal('hide');
}


// WEBPACK FOOTER //
// ./src/routes/index.js